/* IMPECALB Necklace Builder - Multi-Product Version */
(() => {
  const root = document.querySelector("[data-impecalb-builder]");
  if (!root) return;
  
  const baseHandle = root.dataset.baseHandle || "";
  const ornamentHandlesRaw = root.dataset.ornamentHandles || "[]";
  let ornamentHandles = [];
  
  try {
    ornamentHandles = JSON.parse(ornamentHandlesRaw).filter(h => h && h.trim());
  } catch (e) {
    console.error('Failed to parse ornament handles:', e);
  }
  
  const adminNote = document.getElementById("impecalb-adminnote");
  
  if (!baseHandle || ornamentHandles.length === 0) {
    if (adminNote) adminNote.hidden = false;
    return;
  }
  
  const els = {
    topGrid: document.getElementById("impecalb-top-grid"),
    aBase: document.getElementById("impecalb-a-base"),
    aOrn1: document.getElementById("impecalb-a-orn1"),
    bBase: document.getElementById("impecalb-b-base"),
    bOrn2: document.getElementById("impecalb-b-orn2"),
    emptyA: document.getElementById("impecalb-empty"),
    emptyB: document.getElementById("impecalb-empty-b"),
    lineBaseA: document.getElementById("impecalb-line-base"),
    lineOrn1: document.getElementById("impecalb-line-orn1"),
    lineBaseB: document.getElementById("impecalb-line-base-b"),
    lineOrn2: document.getElementById("impecalb-line-orn2"),
    sumNameBase: document.getElementById("impecalb-sum-name-base"),
    sumPriceBase: document.getElementById("impecalb-sum-price-base"),
    sumNameOrn1: document.getElementById("impecalb-sum-name-orn1"),
    sumPriceOrn1: document.getElementById("impecalb-sum-price-orn1"),
    sumRowOrn2: document.getElementById("impecalb-sum-row-orn2"),
    sumNameOrn2: document.getElementById("impecalb-sum-name-orn2"),
    sumPriceOrn2: document.getElementById("impecalb-sum-price-orn2"),
    sumTotal: document.getElementById("impecalb-sum-total"),
    pillsBase: document.getElementById("impecalb-pills-base"),
    orn1Types: document.getElementById("impecalb-orn1-types"),
    orn1Colors: document.getElementById("impecalb-orn1-colors"),
    orn1Separator: document.getElementById("impecalb-orn1-separator"),
    orn1Accordion: document.getElementById("impecalb-orn1-accordion"),
    orn2Types: document.getElementById("impecalb-orn2-types"),
    orn2Colors: document.getElementById("impecalb-orn2-colors"),
    orn2Separator: document.getElementById("impecalb-orn2-separator"),
    orn2Accordion: document.getElementById("impecalb-orn2-accordion"),
    toggleOrn2Btn: document.getElementById("impecalb-toggle-orn2-btn"),
    btnClear: document.getElementById("impecalb-clear"),
    btnAdd: document.getElementById("impecalb-add"),
    orn2Grid: document.getElementById("impecalb-orn2-grid"),
  };
  
  const state = {
    products: { base: null, ornaments: [] },
    selected: { base: null, orn1: null, orn2: null },
    wantOrn2: false,
    orn1SelectedProduct: null,
    orn2SelectedProduct: null,
  };
  
  const NOR = {
    notSelected: "Ikke valgt",
    adding: "Legger til…",
    add: "Legg i handlekurv",
    clear: "Tøm",
    errorAdd: "Kunne ikke legge i handlekurv. Prøv igjen.",
    choiceKey: "Ditt valg",
    choiceBase: "Base",
    choiceOrn1: "Ornament #1",
    choiceOrn2: "Ornament #2",
    unavailable: "Dette valget er ikke tilgjengelig i din region",
  };
  
  const ENG = {
    notSelected: "Not selected",
    adding: "Adding…",
    add: "Add to cart",
    clear: "Clear",
    errorAdd: "Couldn't add to cart. Please try again.",
    choiceKey: "Your choice",
    choiceBase: "Base",
    choiceOrn1: "Ornament #1",
    choiceOrn2: "Ornament #2",
    unavailable: "This selection is not available in your region",
  };
  
  function getLocale() {
    const r = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
    const m = String(r).match(/^\/([A-Za-z-]+)(\/|$)/);
    return m ? String(m[1]).toLowerCase() : "no";
  }
  
  const LOCALE = getLocale();
  const STR = LOCALE === "en" ? ENG : NOR;
  
  function saveState() {
    const toSave = {
      baseId: state.selected.base?.id || null,
      orn1Id: state.selected.orn1?.id || null,
      orn2Id: state.selected.orn2?.id || null,
      wantOrn2: state.wantOrn2,
      orn1ProductHandle: state.orn1SelectedProduct?.handle || null,
      orn2ProductHandle: state.orn2SelectedProduct?.handle || null,
      timestamp: Date.now(),
    };
    sessionStorage.setItem('impecalb_builder_state', JSON.stringify(toSave));
  }
  
  function restoreState() {
    try {
      const saved = sessionStorage.getItem('impecalb_builder_state');
      if (!saved) return;
      const data = JSON.parse(saved);
      if (data.baseId && state.products.base) {
        const variant = state.products.base.variants.find(v => v.id === data.baseId);
        if (variant && variant.available !== false) {
          state.selected.base = variant;
          if (els.pillsBase) {
            Array.from(els.pillsBase.querySelectorAll(".impecalb-pill")).forEach((b) => {
              setPressed(b, b.dataset.variantId === String(variant.id));
            });
          }
        }
      }
      if (data.orn1ProductHandle) {
        const product = state.products.ornaments.find(p => p.handle === data.orn1ProductHandle);
        if (product) {
          state.orn1SelectedProduct = product;
          if (data.orn1Id) {
            const variant = product.variants.find(v => v.id === data.orn1Id);
            if (variant && variant.available !== false) {
              state.selected.orn1 = variant;
              showOrnamentVariants('orn1', product);
              setTimeout(() => {
                if (els.orn1Colors) {
                  Array.from(els.orn1Colors.querySelectorAll(".impecalb-pill")).forEach((b) => {
                    setPressed(b, b.dataset.variantId === String(variant.id));
                  });
                }
              }, 100);
            }
          }
        }
      }
      if (data.wantOrn2) state.wantOrn2 = true;
      if (data.orn2ProductHandle && data.wantOrn2) {
        const product = state.products.ornaments.find(p => p.handle === data.orn2ProductHandle);
        if (product) {
          state.orn2SelectedProduct = product;
          if (data.orn2Id) {
            const variant = product.variants.find(v => v.id === data.orn2Id);
            if (variant && variant.available !== false) {
              state.selected.orn2 = variant;
              showOrnamentVariants('orn2', product);
              setTimeout(() => {
                if (els.orn2Colors) {
                  Array.from(els.orn2Colors.querySelectorAll(".impecalb-pill")).forEach((b) => {
                    setPressed(b, b.dataset.variantId === String(variant.id));
                  });
                }
              }, 100);
            }
          }
        }
      }
    } catch (e) {
      console.error('Failed to restore builder state:', e);
    }
  }
  
  function formatMoney(cents) {
    if (typeof cents !== "number") return "—";
    const currencyCode = window.Shopify?.currency?.active || 'NOK';
    const amount = (cents / 100).toFixed(2);
    const symbols = {'NOK': ' kr','EUR': '€','USD': '$','GBP': '£','SEK': ' kr','DKK': ' kr',};
    const symbol = symbols[currencyCode] || ' ' + currencyCode;
    if (currencyCode === 'EUR' || currencyCode === 'USD' || currencyCode === 'GBP') {
      return symbol + amount;
    }
    return amount + symbol;
  }
  
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return { base: params.get('base') || '', ornament: params.get('ornament') || '', variant: params.get('variant') || '' };
  }
  
  function applyStaticTexts() {
    if (els.btnClear) els.btnClear.textContent = STR.clear;
    if (els.btnAdd) els.btnAdd.textContent = STR.add;
    if (els.lineBaseA) els.lineBaseA.textContent = STR.notSelected;
    if (els.lineOrn1) els.lineOrn1.textContent = STR.notSelected;
    if (els.lineBaseB) els.lineBaseB.textContent = STR.notSelected;
    if (els.lineOrn2) els.lineOrn2.textContent = STR.notSelected;
    if (els.sumNameBase) els.sumNameBase.textContent = STR.notSelected;
    if (els.sumPriceBase) els.sumPriceBase.textContent = "—";
    if (els.sumNameOrn1) els.sumNameOrn1.textContent = STR.notSelected;
    if (els.sumPriceOrn1) els.sumPriceOrn1.textContent = "—";
    if (els.sumNameOrn2) els.sumNameOrn2.textContent = STR.notSelected;
    if (els.sumPriceOrn2) els.sumPriceOrn2.textContent = "—";
    if (els.sumTotal) els.sumTotal.textContent = "—";
  }
  
  function getVariantLabel(product, variant) {
    if (Array.isArray(variant.options) && variant.options.length > 1) {
      return variant.options.slice(1).join(' / ');
    }
    if (Array.isArray(variant.options) && variant.options.length) return String(variant.options[0]);
    if (variant.title && variant.title !== "Default Title") return String(variant.title);
    return product.title || "";
  }
  
  function getVariantImageSrc(product, variant) {
    const fi = variant && variant.featured_image;
    if (fi) {
      if (typeof fi === "string") return fi;
      if (typeof fi === "object" && fi.src) return fi.src;
      if (typeof fi === "object" && fi.url) return fi.url;
    }
    if (variant && variant.image) {
      if (typeof variant.image === "string") return variant.image;
      if (typeof variant.image === "object" && variant.image.src) return variant.image.src;
    }
    if (product && product.featured_image) return product.featured_image;
    if (Array.isArray(product.images) && product.images.length) return product.images[0];
    return "";
  }
  
  function withRoot(path) {
    const r = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
    const cleanRoot = r.endsWith("/") ? r : r + "/";
    const cleanPath = String(path || "").replace(/^\//, "");
    return cleanRoot + cleanPath;
  }
  
  async function fetchProduct(handle) {
    const res = await fetch(withRoot(`products/${handle}.js`), {credentials: "same-origin",});
    if (!res.ok) throw new Error(`Failed to load product: ${handle}`);
    return res.json();
  }
  
  function clearNode(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }
  
  function setPressed(btn, pressed) {
    btn.setAttribute("aria-pressed", pressed ? "true" : "false");
  }
  
  function renderGroup(groupKey, product, targetEl, kind) {
    clearNode(targetEl);
    const isDesktop = window.innerWidth >= 750;
    if (isDesktop && kind !== "type") {
      const wrapper = document.createElement("div");
      wrapper.className = "impecalb-carousel-wrapper";
      const leftArrow = document.createElement("button");
      leftArrow.type = "button";
      leftArrow.className = "impecalb-carousel-arrow";
      leftArrow.innerHTML = "◀";
      leftArrow.disabled = true;
      const container = document.createElement("div");
      container.className = "impecalb-carousel-container";
      targetEl.className = "impecalb-variants-grid impecalb-carousel";
      const rightArrow = document.createElement("button");
      rightArrow.type = "button";
      rightArrow.className = "impecalb-carousel-arrow";
      rightArrow.innerHTML = "▶";
      product.variants.forEach((variant) => {
        const label = getVariantLabel(product, variant);
        const imgSrc = getVariantImageSrc(product, variant);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "impecalb-pill";
        btn.dataset.group = groupKey;
        btn.dataset.variantId = String(variant.id);
        setPressed(btn, state.selected[groupKey]?.id === variant.id);
        const thumb = document.createElement("div");
        thumb.className = "impecalb-pill-img";
        const img = document.createElement("img");
        img.alt = label;
        img.loading = "lazy";
        img.width = 150;
        img.height = 150;
        img.src = imgSrc || "";
        img.setAttribute("data-kind", kind);
        thumb.appendChild(img);
        const text = document.createElement("div");
        text.className = "impecalb-pill-label";
        text.textContent = label;
        const price = document.createElement("div");
        price.className = "impecalb-pill-price";
        price.textContent = formatMoney(Number(variant.price));
        btn.appendChild(thumb);
        btn.appendChild(text);
        btn.appendChild(price);
        btn.addEventListener("click", () => {
          state.selected[groupKey] = variant;
          Array.from(targetEl.querySelectorAll(".impecalb-pill")).forEach((b) => {
            setPressed(b, b.dataset.variantId === String(variant.id));
          });
          updateUI();
          saveState();
        });
        targetEl.appendChild(btn);
      });
      const parent = targetEl.parentNode;
      parent.insertBefore(wrapper, targetEl);
      wrapper.appendChild(leftArrow);
      container.appendChild(targetEl);
      wrapper.appendChild(container);
      wrapper.appendChild(rightArrow);
      
      // **PAGINATION FIX: Base shows 5 items per page**
      let currentIndex = 0;
      const itemsPerPage = 5;
      const totalItems = product.variants.length;
      const maxIndex = totalItems - itemsPerPage;
      
      function updateCarousel() {
        const offset = currentIndex * -174;
        targetEl.style.transform = `translateX(${offset}px)`;
        leftArrow.disabled = currentIndex === 0;
        rightArrow.disabled = currentIndex >= maxIndex;
      }
      
      leftArrow.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex = Math.max(0, currentIndex - itemsPerPage);
          updateCarousel();
        }
      });
      
      rightArrow.addEventListener("click", () => {
        if (currentIndex < maxIndex) {
          currentIndex = Math.min(maxIndex, currentIndex + itemsPerPage);
          updateCarousel();
        }
      });
      
      updateCarousel();
    } else {
      product.variants.forEach((variant) => {
        const label = getVariantLabel(product, variant);
        const imgSrc = getVariantImageSrc(product, variant);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "impecalb-pill";
        btn.dataset.group = groupKey;
        btn.dataset.variantId = String(variant.id);
        setPressed(btn, state.selected[groupKey]?.id === variant.id);
        const thumb = document.createElement("div");
        thumb.className = "impecalb-pill-img";
        const img = document.createElement("img");
        img.alt = label;
        img.loading = "lazy";
        img.width = 150;
        img.height = 150;
        img.src = imgSrc || "";
        img.setAttribute("data-kind", kind);
        thumb.appendChild(img);
        const text = document.createElement("div");
        text.className = "impecalb-pill-label";
        text.textContent = label;
        const price = document.createElement("div");
        price.className = "impecalb-pill-price";
        price.textContent = formatMoney(Number(variant.price));
        btn.appendChild(thumb);
        btn.appendChild(text);
        btn.appendChild(price);
        btn.addEventListener("click", () => {
          state.selected[groupKey] = variant;
          Array.from(targetEl.querySelectorAll(".impecalb-pill")).forEach((b) => {
            setPressed(b, b.dataset.variantId === String(variant.id));
          });
          updateUI();
          saveState();
        });
        targetEl.appendChild(btn);
      });
    }
  }
  
  function renderAllOrnamentTypes(groupKey, ornamentProducts, targetEl) {
    clearNode(targetEl);
    ornamentProducts.forEach((product) => {
      const firstVariant = product.variants[0];
      if (!firstVariant) return;
      const imgSrc = getVariantImageSrc(product, firstVariant);
      const card = document.createElement("div");
      card.className = "impecalb-type-card";
      const imgWrapper = document.createElement("div");
      imgWrapper.className = "impecalb-pill-img";
      const img = document.createElement("img");
      img.src = imgSrc || "";
      img.alt = product.title;
      img.width = 150;
      img.height = 150;
      img.loading = "lazy";
      img.setAttribute("data-kind", "ornament");
      imgWrapper.appendChild(img);
      const title = document.createElement("h3");
      title.className = "impecalb-pill-label impecalb-type-label-bold";
      title.textContent = product.title;
      card.appendChild(imgWrapper);
      card.appendChild(title);
      card.addEventListener("click", () => {
        if (groupKey === 'orn1') state.orn1SelectedProduct = product;
        else if (groupKey === 'orn2') state.orn2SelectedProduct = product;
        showOrnamentVariants(groupKey, product);
        saveState();
      });
      targetEl.appendChild(card);
    });
  }
  
  function showOrnamentVariants(groupKey, product) {
    const colorsEl = groupKey === 'orn1' ? els.orn1Colors : els.orn2Colors;
    const separatorEl = groupKey === 'orn1' ? els.orn1Separator : els.orn2Separator;
    const accordionEl = groupKey === 'orn1' ? els.orn1Accordion : els.orn2Accordion;
    
    if (!product || !colorsEl || !accordionEl) return;
    
    const existingWrappers = accordionEl.querySelectorAll('.impecalb-carousel-wrapper');
    existingWrappers.forEach(wrapper => wrapper.remove());
    
    colorsEl.className = "impecalb-variants-grid";
    colorsEl.style.transform = "";
    colorsEl.style.display = "none";
    clearNode(colorsEl);
    
    const isDesktop = window.innerWidth >= 750;
    
    if (isDesktop) {
      const wrapper = document.createElement("div");
      wrapper.className = "impecalb-carousel-wrapper";
      const leftArrow = document.createElement("button");
      leftArrow.type = "button";
      leftArrow.className = "impecalb-carousel-arrow";
      leftArrow.innerHTML = "◀";
      leftArrow.disabled = true;
      const container = document.createElement("div");
      container.className = "impecalb-carousel-container";
      colorsEl.className = "impecalb-variants-grid impecalb-carousel";
      const rightArrow = document.createElement("button");
      rightArrow.type = "button";
      rightArrow.className = "impecalb-carousel-arrow";
      rightArrow.innerHTML = "▶";
      
      product.variants.forEach((variant) => {
        const label = getVariantLabel(product, variant);
        const imgSrc = getVariantImageSrc(product, variant);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "impecalb-pill";
        btn.dataset.group = groupKey;
        btn.dataset.variantId = String(variant.id);
        setPressed(btn, state.selected[groupKey]?.id === variant.id);
        const thumb = document.createElement("div");
        thumb.className = "impecalb-pill-img";
        const img = document.createElement("img");
        img.alt = label;
        img.loading = "lazy";
        img.width = 150;
        img.height = 150;
        img.src = imgSrc || "";
        img.setAttribute("data-kind", "ornament");
        thumb.appendChild(img);
        const text = document.createElement("div");
        text.className = "impecalb-pill-label";
        text.textContent = label;
        const price = document.createElement("div");
        price.className = "impecalb-pill-price";
        price.textContent = formatMoney(Number(variant.price));
        btn.appendChild(thumb);
        btn.appendChild(text);
        btn.appendChild(price);
        btn.addEventListener("click", () => {
          state.selected[groupKey] = variant;
          Array.from(colorsEl.querySelectorAll(".impecalb-pill")).forEach((b) => {
            setPressed(b, b.dataset.variantId === String(variant.id));
          });
          updateUI();
          saveState();
        });
        colorsEl.appendChild(btn);
      });
      
      accordionEl.appendChild(wrapper);
      wrapper.appendChild(leftArrow);
      container.appendChild(colorsEl);
      wrapper.appendChild(container);
      wrapper.appendChild(rightArrow);
      
      // **PAGINATION FIX: Ornaments show 3 items per page**
      let currentIndex = 0;
      const itemsPerPage = 3;
      const totalItems = product.variants.length;
      const maxIndex = totalItems - itemsPerPage;
      
      function updateCarousel() {
        const offset = currentIndex * -174;
        colorsEl.style.transform = `translateX(${offset}px)`;
        leftArrow.disabled = currentIndex === 0;
        rightArrow.disabled = currentIndex >= maxIndex;
      }
      
      leftArrow.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex = Math.max(0, currentIndex - itemsPerPage);
          updateCarousel();
        }
      });
      
      rightArrow.addEventListener("click", () => {
        if (currentIndex < maxIndex) {
          currentIndex = Math.min(maxIndex, currentIndex + itemsPerPage);
          updateCarousel();
        }
      });
      
      updateCarousel();
      
    } else {
      product.variants.forEach((variant) => {
        const label = getVariantLabel(product, variant);
        const imgSrc = getVariantImageSrc(product, variant);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "impecalb-pill";
        btn.dataset.group = groupKey;
        btn.dataset.variantId = String(variant.id);
        setPressed(btn, state.selected[groupKey]?.id === variant.id);
        const thumb = document.createElement("div");
        thumb.className = "impecalb-pill-img";
        const img = document.createElement("img");
        img.alt = label;
        img.loading = "lazy";
        img.width = 150;
        img.height = 150;
        img.src = imgSrc || "";
        img.setAttribute("data-kind", "ornament");
        thumb.appendChild(img);
        const text = document.createElement("div");
        text.className = "impecalb-pill-label";
        text.textContent = label;
        const price = document.createElement("div");
        price.className = "impecalb-pill-price";
        price.textContent = formatMoney(Number(variant.price));
        btn.appendChild(thumb);
        btn.appendChild(text);
        btn.appendChild(price);
        btn.addEventListener("click", () => {
          state.selected[groupKey] = variant;
          Array.from(colorsEl.querySelectorAll(".impecalb-pill")).forEach((b) => {
            setPressed(b, b.dataset.variantId === String(variant.id));
          });
          updateUI();
          saveState();
        });
        colorsEl.appendChild(btn);
      });
    }
    
    if (separatorEl) separatorEl.style.display = 'block';
    colorsEl.style.display = 'flex';
    setTimeout(() => {
      if (separatorEl) separatorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }
  
  function showPreviewImage(imgEl, src) {
    if (!imgEl) return;
    if (!src) { imgEl.style.display = "none"; imgEl.removeAttribute("src"); return; }
    imgEl.src = src;
    imgEl.style.display = "block";
  }
  
  function setLogoOverlayVisible(visible) {
    if (els.emptyA) els.emptyA.style.display = visible ? "grid" : "none";
    if (els.emptyB) els.emptyB.style.display = visible ? "grid" : "none";
  }
  
  function updateSummary() {
    const baseV = state.selected.base;
    const orn1V = state.selected.orn1;
    const orn2V = state.selected.orn2;
    const baseName = baseV ? getVariantLabel(state.products.base, baseV) : STR.notSelected;
    const orn1Name = orn1V && state.orn1SelectedProduct ? `${state.orn1SelectedProduct.title} - ${getVariantLabel(state.orn1SelectedProduct, orn1V)}` : STR.notSelected;
    const orn2Name = state.wantOrn2 && orn2V && state.orn2SelectedProduct ? `${state.orn2SelectedProduct.title} - ${getVariantLabel(state.orn2SelectedProduct, orn2V)}` : STR.notSelected;
    if (els.sumNameBase) els.sumNameBase.textContent = baseName;
    if (els.sumNameOrn1) els.sumNameOrn1.textContent = orn1Name;
    if (els.sumNameOrn2) els.sumNameOrn2.textContent = orn2Name;
    const basePrice = baseV ? Number(baseV.price) : null;
    const orn1Price = orn1V ? Number(orn1V.price) : null;
    const orn2Price = state.wantOrn2 && orn2V ? Number(orn2V.price) : null;
    if (els.sumPriceBase) els.sumPriceBase.textContent = basePrice != null ? formatMoney(basePrice) : "—";
    if (els.sumPriceOrn1) els.sumPriceOrn1.textContent = orn1Price != null ? formatMoney(orn1Price) : "—";
    if (els.sumPriceOrn2) els.sumPriceOrn2.textContent = orn2Price != null ? formatMoney(orn2Price) : "—";
    const totalCents = (basePrice != null ? basePrice : 0) + (orn1Price != null ? orn1Price : 0) + (orn2Price != null ? orn2Price : 0);
    const hasAnyPrice = basePrice != null || orn1Price != null || orn2Price != null;
    if (els.sumTotal) els.sumTotal.textContent = hasAnyPrice ? formatMoney(totalCents) : "—";
  }
  
  function updateUI() {
    const baseV = state.selected.base;
    const orn1V = state.selected.orn1;
    const orn2V = state.selected.orn2;
    if (els.lineBaseA) els.lineBaseA.textContent = baseV ? getVariantLabel(state.products.base, baseV) : STR.notSelected;
    if (els.lineOrn1) {
      const orn1Text = orn1V && state.orn1SelectedProduct ? `${state.orn1SelectedProduct.title} - ${getVariantLabel(state.orn1SelectedProduct, orn1V)}` : STR.notSelected;
      els.lineOrn1.textContent = orn1Text;
    }
    if (els.lineBaseB) els.lineBaseB.textContent = baseV ? getVariantLabel(state.products.base, baseV) : STR.notSelected;
    if (els.lineOrn2) {
      const orn2Text = state.wantOrn2 && orn2V && state.orn2SelectedProduct ? `${state.orn2SelectedProduct.title} - ${getVariantLabel(state.orn2SelectedProduct, orn2V)}` : STR.notSelected;
      els.lineOrn2.textContent = orn2Text;
    }
    if (els.topGrid) {
      if (state.wantOrn2) els.topGrid.classList.add('impecalb-show-orn2');
      else els.topGrid.classList.remove('impecalb-show-orn2');
    }
    if (els.orn2Grid) {
      if (state.wantOrn2) els.orn2Grid.classList.add('impecalb-orn2-active');
      else els.orn2Grid.classList.remove('impecalb-orn2-active');
    }
    const baseSrc = baseV ? getVariantImageSrc(state.products.base, baseV) : "";
    const orn1Src = orn1V && state.orn1SelectedProduct ? getVariantImageSrc(state.orn1SelectedProduct, orn1V) : "";
    const orn2Src = state.wantOrn2 && orn2V && state.orn2SelectedProduct ? getVariantImageSrc(state.orn2SelectedProduct, orn2V) : "";
    showPreviewImage(els.aBase, baseSrc);
    showPreviewImage(els.aOrn1, orn1Src);
    showPreviewImage(els.bBase, baseSrc);
    showPreviewImage(els.bOrn2, orn2Src);
    const hasAnySelection = !!(baseV || orn1V || orn2V);
    setLogoOverlayVisible(!hasAnySelection);
    updateSummary();
    const ok = !!(baseV && orn1V && (!state.wantOrn2 || orn2V));
    if (els.btnAdd) els.btnAdd.disabled = !ok;
  }
  
  async function addToCart() {
    const baseV = state.selected.base;
    const orn1V = state.selected.orn1;
    const orn2V = state.selected.orn2;
    if (!baseV || !orn1V) return;
    if (state.wantOrn2 && !orn2V) return;
    const groupId = String(Date.now());
    const items = [
      {id: baseV.id,quantity: 1,properties: {_impecalb_builder: "1",_impecalb_group: groupId,[STR.choiceKey]: STR.choiceBase,},},
      {id: orn1V.id,quantity: 1,properties: {_impecalb_builder: "1",_impecalb_group: groupId,[STR.choiceKey]: STR.choiceOrn1,},},
    ];
    if (state.wantOrn2 && orn2V) {
      items.push({id: orn2V.id,quantity: 1,properties: {_impecalb_builder: "1",_impecalb_group: groupId,[STR.choiceKey]: STR.choiceOrn2,},});
    }
    const oldText = els.btnAdd ? els.btnAdd.textContent : "";
    if (els.btnAdd) { els.btnAdd.disabled = true; els.btnAdd.textContent = STR.adding; }
    try {
      const res = await fetch(withRoot("cart/add.js"), {method: "POST",headers: { "Content-Type": "application/json", Accept: "application/json" },credentials: "same-origin",body: JSON.stringify({ items }),});
      if (!res.ok) throw new Error("Add failed");
      sessionStorage.removeItem('impecalb_builder_state');
      window.location.href = withRoot("cart");
    } catch (e) {
      alert(STR.errorAdd);
      if (els.btnAdd) { els.btnAdd.disabled = false; els.btnAdd.textContent = oldText || STR.add; }
    }
  }
  
  function clearAll() {
    state.selected.base = null;
    state.selected.orn1 = null;
    state.selected.orn2 = null;
    state.wantOrn2 = false;
    state.orn1SelectedProduct = null;
    state.orn2SelectedProduct = null;
    if (els.pillsBase) Array.from(els.pillsBase.querySelectorAll(".impecalb-pill")).forEach((b) => setPressed(b, false));
    if (els.orn1Colors) { clearNode(els.orn1Colors); els.orn1Colors.style.display = 'none'; }
    if (els.orn1Separator) els.orn1Separator.style.display = 'none';
    if (els.orn2Colors) { clearNode(els.orn2Colors); els.orn2Colors.style.display = 'none'; }
    if (els.orn2Separator) els.orn2Separator.style.display = 'none';
    sessionStorage.removeItem('impecalb_builder_state');
    updateUI();
  }
  
  function autoSelectFromUrl(urlParams) {
    if (urlParams.base && urlParams.base === baseHandle && state.products.base) {
      let variantToSelect = state.products.base.variants[0];
      if (urlParams.variant) {
        const foundVariant = state.products.base.variants.find(v => String(v.id) === urlParams.variant);
        if (foundVariant) variantToSelect = foundVariant;
      }
      if (variantToSelect) {
        state.selected.base = variantToSelect;
        if (els.pillsBase) {
          Array.from(els.pillsBase.querySelectorAll(".impecalb-pill")).forEach((b) => {
            setPressed(b, b.dataset.variantId === String(variantToSelect.id));
          });
        }
      }
    }
    if (urlParams.ornament) {
      const ornamentProduct = state.products.ornaments.find(p => p.handle === urlParams.ornament);
      if (ornamentProduct) {
        let variantToSelect = ornamentProduct.variants[0];
        if (urlParams.variant) {
          const foundVariant = ornamentProduct.variants.find(v => String(v.id) === urlParams.variant);
          if (foundVariant) variantToSelect = foundVariant;
        }
        if (variantToSelect) {
          state.selected.orn1 = variantToSelect;
          state.orn1SelectedProduct = ornamentProduct;
          showOrnamentVariants('orn1', ornamentProduct);
          setTimeout(() => {
            if (els.orn1Colors) {
              Array.from(els.orn1Colors.querySelectorAll(".impecalb-pill")).forEach((b) => {
                setPressed(b, b.dataset.variantId === String(variantToSelect.id));
              });
            }
          }, 100);
        }
      }
    }
  }
  
  async function init() {
    applyStaticTexts();
    const urlParams = getUrlParams();
    try {
      state.products.base = await fetchProduct(baseHandle);
      const ornamentPromises = ornamentHandles.map(h => fetchProduct(h));
      state.products.ornaments = await Promise.all(ornamentPromises);
      renderGroup("base", state.products.base, els.pillsBase, "base");
      renderAllOrnamentTypes("orn1", state.products.ornaments, els.orn1Types);
      renderAllOrnamentTypes("orn2", state.products.ornaments, els.orn2Types);
      if (els.toggleOrn2Btn) {
        els.toggleOrn2Btn.addEventListener("click", () => {
          state.wantOrn2 = !state.wantOrn2;
          if (!state.wantOrn2) {
            state.selected.orn2 = null;
            state.orn2SelectedProduct = null;
            if (els.orn2Colors) { clearNode(els.orn2Colors); els.orn2Colors.style.display = 'none'; }
            if (els.orn2Separator) els.orn2Separator.style.display = 'none';
          }
          updateUI();
          saveState();
        });
      }
      if (els.btnClear) els.btnClear.addEventListener("click", clearAll);
      if (els.btnAdd) els.btnAdd.addEventListener("click", addToCart);
      autoSelectFromUrl(urlParams);
      restoreState();
      updateUI();
    } catch (e) {
      console.error('Builder initialization error:', e);
      if (adminNote) adminNote.hidden = false;
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const summaryBox = document.querySelector('.impecalb-summary-box');
    const summaryTitle = summaryBox?.querySelector('h3');
    if (summaryBox && summaryTitle && window.innerWidth <= 749) {
      summaryBox.classList.add('impecalb-collapsed');
      summaryTitle.addEventListener('click', function() {
        summaryBox.classList.toggle('impecalb-collapsed');
      });
    }
    window.addEventListener('resize', function() {
      if (window.innerWidth > 749) summaryBox?.classList.remove('impecalb-collapsed');
      else if (summaryBox && !summaryBox.classList.contains('impecalb-collapsed')) summaryBox.classList.add('impecalb-collapsed');
    });
  });
  
  init();
})();
